const cosmeticsCategories = {
  skincare: {
    name: 'skincare',
    categories: {
      all: 'all',
      lip: 'lip',
      eye: 'eye',
      cleansers: 'cleansers',
      masks: 'masks',
      moisturizers: 'moisturizers',
      treatments: 'treatments',
      mens: 'mens',
      wellness: 'wellness',
    },
  },
  personalCare: {
    name: 'personalCare',
    categories: {
      all: 'all',
      bodyMoisturizers: 'bodyMoisturizers',
      handCreams: 'handCreams',
      shower: 'shower',
    },
  },
  makeup: {
    name: 'makeup',
    categories: {
      all: 'all',
      palettes: 'palettes',
      eye: 'eye',
      lip: 'lip',
      face: 'face',
      cheek: 'cheek',
      tools: 'tools',
    },
  },
} as const


export type CosmeticsCategories = typeof cosmeticsCategories

export default cosmeticsCategories
